import { FormattedDate } from '../FormattedDate';
import { TagSmall } from '../tag-small';

type Props = {
  href: string;
  heroImage?: string | null | undefined;
  heroImageAlt?: string | null;
  title: string;
  description?: string;
  authorImage?: string | null;
  author: string;
  pubDate: string;
  tags?: ReadonlyArray<string> | undefined;
};

export function CardMedium(props: Props) {
  const {
    href,
    heroImage,
    heroImageAlt,
    title,
    description,
    authorImage,
    author,
    pubDate,
    tags,
  } = props;

  return (
    <li className='w-full max-w-[306px] min-w-[230px] list-none'>
      <a
        className='flex h-full flex-col items-start'
        href={href}
        rel='noreferrer'
        target='_blank'
      >
        <img
          alt={heroImageAlt ?? undefined}
          className='w-full rounded-2xl object-cover'
          height={360}
          src={heroImage ?? undefined}
          width={720}
        />

        {/* <!-- Content section with flex-grow to push footer to bottom --> */}
        <div className='mt-5 mb-4 flex max-w-full flex-1 flex-col gap-2'>
          <h4 className='line-clamp-2 text-xl leading-tight font-semibold text-black'>
            {title}
          </h4>
          {description && (
            <div
              className='line-clamp-2 text-base leading-normal text-neutral-500'
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>

        {/* <!-- Footer section - always at bottom --> */}
        <div className='mt-auto flex w-full max-w-full flex-col gap-3'>
          {tags && tags.length > 0 && (
            <div className='flex flex-wrap items-center gap-2'>
              {tags.slice(0, 3).map((tag, index) => (
                <TagSmall key={`${tag}-${index.toString()}`} tagName={tag} />
              ))}
            </div>
          )}

          <div className='flex items-center gap-2 overflow-hidden'>
            <div className='flex items-center gap-2 overflow-hidden'>
              {authorImage && (
                <img
                  alt='Author profile'
                  className='size-6 rounded-full'
                  height={24}
                  src={authorImage ?? undefined}
                  width={24}
                />
              )}

              <p className='truncate text-xs leading-3 font-normal text-neutral-500'>
                {author}
              </p>
            </div>
            <p className='text-xs leading-3 font-medium text-neutral-500'>•</p>
            <p className='w-24 shrink-0 text-xs leading-3 font-normal text-neutral-500'>
              <FormattedDate date={pubDate} />
            </p>
          </div>
        </div>
      </a>
    </li>
  );
}
